<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content">
      <ion-grid fixed>
        <!-- <erklaerung-arag-zahn /> -->
        <div class="ion-padding">
          <!-- <div
            class="c-header u-bg-orange -contain"
            :style="{
              'background-image':
                'url(' + require('@/assets/img/slider/arag_zahn.svg') + ')',
            }"
          >
            <img
              class="c-header__logo"
              width="40"
              src="@/assets/img/arag_logo.png"
            />
          </div> -->
          <Header
            class="u-bg-orange -contain"
            headline="Persönliche Unterstützung vor schweren Zahnbehandlungen."
            :image="require('@/assets/img/slider/arag_zahn.svg')"
            :logo="require('@/assets/img/arag_logo.png')"
            logoWidth="40"
            hideButton />
          <p class="ion-padding-top ion-hide-lg-up">
            <b>Persönliche Unterstützung vor schweren Zahnbehandlungen.</b>
          </p>
          <p>
            Steht Ihnen eine Zahnbehandlung bevor oder haben Sie noch
            Beschwerden nach einer Behandlung? Ein ARAG Gesundheitsassistent
            betreut Sie und nimmt sich individuell Ihrem Anliegen an. Gemeinsam
            mit Ihnen kümmert er sich um die bestmögliche Lösung.
          </p>
          <p>
            Er unterstützt Sie, einen geeigneten Zahnarzt oder Spezialisten zu
            finden oder organisiert für Sie eine Zweitmeinung.
          </p>
          <div class="c-card ion-text-center -orange">
            <ion-row class="ion-align-items-center">
              <ion-col>
                <img src="@/assets/img/header/icon_zahnarzt.svg" />
              </ion-col>
              <ion-col>
                <img src="@/assets/img/home/icon_zweitmeinung_iso.svg" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <div>Zahnarztsuche</div>
              </ion-col>
              <ion-col>
                <div>Zweitmeinung</div>
              </ion-col>
            </ion-row>
          </div>
          <p>
            Ziel der ARAG Gesundheitsassistenten ist es, Sie von Ihren
            Zahnschmerzen zu befreien und langwierigen Bahndlungen ein Ende zu
            setzen.
          </p>
          <!-- <p>
          <b>NEU für unsere Kunden in Süd-Deutschland:</b>
          Wir unterstützen Sie ab sofort auch bei der Suche eines neuen
          Zahnarztes! Sie erhalten exklusiven und schnellen Zugang zu den
          Zahnärzten der Zahnärztlichen Tageskliniken.
        </p> -->
          <!-- <div class="c-line"></div> -->
          <!-- <div class="ion-margin-vertical">
            <img width="50" src="@/assets/img/arag_logo.png" />
          </div> -->
          <!-- <ion-row class="ion-align-items-center">
            <ion-col>
              <ion-button
                size="small"
                fill="clear"
                class="ion-text-wrap ion-no-padding"
                @click="openKostenerstattungModal"
                >Kostenrückerstattung&nbsp;
                <ion-icon :icon="helpCircle" />
              </ion-button>
            </ion-col>
          </ion-row> -->
          <ion-row class="ion-margin-top ion-text-center">
            <ion-col>
              <a
                href="#"
                @click.prevent="$router.push({ name: 'arag-zahn-anleitung' })"
                >So funktioniert's</a
              >
            </ion-col>
            <ion-col>
              <a href="#" @click.prevent="openKostenerstattungModal"
                >Kostenrückerstattung</a
              >
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top">
            <ion-col size="6">
              <div
                class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
                style="
                  height: 100%;
                  cursor: pointer;
                  padding: 16px 8px 16px 8px;
                "
                @click="openFormContact">
                <ion-icon
                  style="font-size: 32px; margin-bottom: 10px"
                  :src="require('@lib/assets/icons/icon_incoming.svg')"
                  slot="start"></ion-icon>
                <br />
                Jetzt Kontakt aufnehmen
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
                style="
                  height: 100%;
                  cursor: pointer;
                  padding: 16px 8px 16px 8px;
                "
                @click="
                  $router.push({
                    name: 'home',
                    params: {
                      shouldShowDentistSearch: true,
                      from: 'aragZahn',
                    },
                  })
                ">
                <ion-icon
                  style="font-size: 32px; margin-bottom: 10px"
                  :src="require('@lib/assets/icons/roodie-white_orange.svg')"
                  slot="start"></ion-icon>
                <br />
                Roodie.Check starten
              </div>
            </ion-col>
          </ion-row>
          <!-- <div class="c-cta">
            <ion-button class="ion-margin-top" @click="openFormContact"
              >Jetzt Kontakt aufnehmen&nbsp;
              <ion-icon
                :src="require('@lib/assets/icons/roodie-white.svg')"
                slot="end"
              ></ion-icon
            ></ion-button>
          </div> -->
        </div>
        <!-- <div
          class="ion-margin-top ion-padding ion-text-center u-color-primary u-bold u-box-shadow u-bg-light"
        ></div> -->
        <ion-modal
          :is-open="showPartnerModal"
          :css-class="['c-autoheight-modal']"
          @didDismiss="showPartnerModal = false">
          <ion-page class="ion-padding ion-text-center u-color-primary u-bold">
            <modal-close />
            <roodie fillOuter="#5E58BE" :expression="'happy'" />
            <div class="ion-margin-top u-medium">
              NEUER PARTNER<br />
              in S-Deutschland:
            </div>
            <div class="u-large ion-margin-top ion-padding-top">
              Zahnärztliche Tageskliniken
            </div>
            <p>
              Wir unterstützen Sie ab sofort auch bei der Suche eines neuen
              Zahnarztes im Süden Deutschlands! So erhalten Sie einen schnellen
              Zugang zu den besten Zahnärzten.
            </p>
            <div class="u-medium">Exklusiv für Sie!</div>
            <img
              class="ion-margin-vertical"
              src="@/assets/img/slider/tagesklinik.svg"
              width="130" />
            <div>
              <ion-button
                @click="showPartnerModal = false"
                router-link="/zahnarzt-ztk"
                fill="outline"
                >Nähere Informationen</ion-button
              >
            </div>
          </ion-page>
        </ion-modal>
        <!-- <div class="ion-margin-top">
          <img width="50" src="@arag/assets/img/arag_logo.png" />
        </div>
        <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_call.svg') +
                  ')',
              }"
              @click="$router.push({ path: '/arag-zahn/anleitung' })"
            >
              <div class="c-nugget__label">
                So einfach geht's
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/browser-anfrage.svg') +
                  ')',
              }"
              @click="
                $router.push({
                  name: 'datenschutz',
                  params: {
                    routing: 'ARAG Case Management Zahn',
                    shouldOpenFormContact: true,
                  },
                })
              "
            >
              <div class="c-nugget__label">
                Termin buchen
              </div>
            </div>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack, helpCircle } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  IonModal,
  IonBackButton,
} from "@ionic/vue";
// import ErklaerungAragZahn from "@/components/ErklaerungAragZahn";
import FormContact from "@/components/FormContact";
import Roodie from "@lib/components/svg/Roodie";
import KostenerstattungModal from "@arag/components/KostenerstattungAragZahnModal";
import ModalClose from "@lib/components/ModalClose";
import Header from "@/components/Header";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    // ErklaerungAragZahn,
    Roodie,
    IonModal,
    ModalClose,
    Header,
    IonBackButton,
  },
  data() {
    return {
      showPartnerModal: false,
    };
  },
  setup() {
    return {
      chevronBack,
      helpCircle,
    };
  },
  methods: {
    async openFormContact() {
      const modal = await modalController.create({
        component: FormContact,
        componentProps: {
          routing: "ARAG Case Management Zahn",
          reference: "Kontakt aufnehmen",
        },
      });
      return modal.present();
    },
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped></style>
